<template>
    <div class="">
        <div class="uk-container">
            <h2 class="uk-heading-bullet">General Requirements</h2>
            <p>
                Students seeking admission into the baccalaureate programmes must comply with at least one of the following requirements:
            </p>
            <div class="uk-child-width-1-2@m" uk-grid>
                <div>
                    <ul class="uk-list uk-list-bullet">
                        <li>
                            Five General Certificate of Education (GCE) or Caribbean Examinations Council (CXC) passes (at a minimum of level III or Grade C) or equivalent, including English Language.
                            Only two (2) grade 3 subject passes are applicable.
                        </li>
                        <li>
                            Four General Certificate of Education (GCE) or
                            Caribbean Examinations Council (CXC) passes (at a minimum level of level III or Grade C) and
                            one Secondary School Certificate (SSC) pass in the National Assessment, Range 5, including English Language.
                        </li>
                        <li>
                            A minimum score of 1170 on the Scholastic Aptitude Test (SAT I) for students outside the English Speaking Caribbean, where 1, 2 and 3 above do not apply.
                        </li>
                    </ul>
                </div>
                <div>
                    <ul class="uk-list uk-list-bullet">


                        <li>
                            Transfer from a recognised tertiary institution with at least sophomore standing, (minimum of 32 transferable semester credits),
                            and must have satisfied matriculation requirements at that institution. Students transferring with
                            less than 32 credits will be classified as freshmen and all NCU matriculation requirements will apply.
                        </li>
                        <li>
                            A minimum Scholastic Aptitude Test (SAT II) of 650 for individual subjects is required for science programmes.
                        </li>
                        <li>
                            A three year diploma or associate degree from an approved tertiary institution. ( Not required for Associate Degree applicants )
                        </li>
                        <li>
                            ACT composite score of 26.
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "requirements"
    }
</script>

<style scoped>
    @media screen and (max-width:600px){


        h2{
            font-size: 1.1em !important;
        }
        p,li{
            font-size: 0.8em !important;
        }


    }
</style>
